module.exports = __webpack_public_path__ + "img/landing-bg-new.90ba0867.png";